import { SuperService } from './../../core/services/super.service';
import { AuthService } from '../../core/services/auth.service';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../core/services/user.service';
import { UtilsService } from '../../core/services/utils.service';
import { NotificationService } from '../../core/services/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationsComponent } from '../modals/notifications/notifications.component';

@Component({
	selector: 'app-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
	mobileQuery: MediaQueryList;
	fillerNav = Array.from({ length: 3 }, (_, i) => `Nav Item ${i + 1}`);
	matNavList;
	superUser = Boolean(localStorage.getItem('superUser'));
	adminUser = Boolean(localStorage.getItem('adminUser'));

	activePage: string = null;

	private _mobileQueryListener: () => void;

	user = {
		username: '',
		locale: '',
	};

	constructor(
		changeDetectorRef: ChangeDetectorRef,
		media: MediaMatcher,
		private userService: UserService,
		private toggleActionsService: UtilsService,
		private router: Router,
		private authService: AuthService,
		private notificationService: NotificationService,
		public dialog: MatDialog
	) {
		this.mobileQuery = media.matchMedia('(max-width: 1140px)');
		this._mobileQueryListener = () => changeDetectorRef.detectChanges();
		this.mobileQuery.addListener(this._mobileQueryListener);

		router.events.subscribe((val) => {
			this.changeActiveItem();
		});
	}

	openNotifications(): void {
		const notifications = this.notificationService.getNotifications();

		this.dialog.open(NotificationsComponent, {
			data: {
				notifications: notifications,
				panelClass: 'notifications',
				position: { right: '4%', top: '4%' },
			},
		});
	}

	changeActiveItem() {
		const isHome = window.location.href.split('/')[3] == 'home';
		const currentPage = window.location.href.split('/')[4];

		switch (currentPage) {
			case undefined && isHome:
				this.activePage = 'home';
				break;
			case 'manage-users':
				this.activePage = 'users';
				break;
			case 'ocurrences':
				this.activePage = 'ocurrences';
				break;
			case 'real-time':
				this.activePage = 'real-time';
				break;
			default:
				this.activePage = null;
				break;
		}
	}

	newNotification: boolean = false;

	verifyNewNotifications(): void {
		this.newNotification = this.notificationService.newNotification();
	}

	ngOnInit(): void {
		this.getUser();

		setInterval(() => {
			this.verifyNewNotifications();
		}, 1000);
	}

	ngOnDestroy(): void {
		this.mobileQuery.removeListener(this._mobileQueryListener);
	}

	logout(): void {
		this.authService.logout();
	}

	getUser(): void {
		this.userService.getSelfUserOp().subscribe((res) => {
			const locale = res?.UserAttributes.filter((x) => x.Name == 'locale');
			const nome = res?.UserAttributes.filter((x) => x.Name == 'name');
			if (locale.length > 0 && nome.length > 0) {
				this.user.locale = locale[0].Value;
				this.user.username = nome[0].Value;
			}
		});
	}

	menuAction(): void {
		this.toggleActionsService.sendMenuClickEvent();
	}

	backToHome(): void {
		this.router.navigate(['/home']);
	}
}
